import { ComponentProps } from "react";

import cn from "@/helpers/classNames";

import Pagination from "../pagination/Pagination";

export function TablePagination(
  props: {
    pageIndex: number;
    pageCount: number;
    pageSize: number;
    canNextPage: boolean;
    canPreviousPage: boolean;
    onChangePage: (pageIndex: number) => void;
    totalRows: number;
  } & ComponentProps<"div">,
) {
  const {
    pageIndex,
    pageSize,
    totalRows,
    canNextPage,
    canPreviousPage,
    pageCount,
    onChangePage,
    ...divProps
  } = props;
  const pageStart = pageIndex * pageSize + 1;
  const pageEnd = Math.min((pageIndex + 1) * pageSize, totalRows);
  return (
    <div
      {...divProps}
      className={cn("flex items-center justify-between", divProps.className)}
    >
      <div className="ml-auto flex items-center gap-x-6 lg:gap-x-8">
        <div className="text-sm text-muted-foreground">
          Showing{" "}
          <span className="font-medium text-foreground">
            {pageStart}-{pageEnd}
          </span>{" "}
          of <span className="font-medium text-foreground">{totalRows}</span>{" "}
          {totalRows === 1 ? "sync" : "syncs"}
        </div>
        {(canPreviousPage || canNextPage) && (
          <Pagination
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            gotoPage={onChangePage}
            pageCount={pageCount}
            pageIndex={pageIndex}
          />
        )}
      </div>
    </div>
  );
}
